/**
 * Help for new arrivals: links to the wiki on the sign-in and world screens and in Settings,
 * and a short "How to play" sheet anyone can open before (or after) they sign in.
 */

/** The wiki lives next to the game: play.example.com → wiki.example.com. */
export function wikiUrl(): string {
  const h = location.hostname;
  if (/^play\./.test(h)) return `${location.protocol}//${h.replace(/^play\./, 'wiki.')}/`;
  return 'https://wiki.sunderfen.com/';
}

const HOW = [
  ['Moving', 'Tap or click the ground to walk there. Drag to turn the camera; pinch or scroll to zoom.'],
  ['Doing things', 'Tap a tree, rock, fishing spot, fire or person to use it. Long-press (or right-click) for more choices.'],
  ['Quests', 'People with a gold marker have work for you. The Quests tab lists what you are on; tap one to track it, and the marker shows where to go.'],
  ['Skills and gear', 'Every skill levels as you use it. Better tools come from better metal, so mining feeds smithing, and smithing feeds everything else.'],
  ['Your pack', 'The Pack tab holds what you carry. Banks keep the rest. Gear goes on from the Pack; the Gear tab shows what you wear.'],
  ['Night', 'Shops shut at night and townsfolk go home. Their door has a lantern: tap it to knock and they will still talk to you.'],
  ['The map', 'The map button opens the valley as far as you have explored. Tap a place to walk there.'],
  ['Stuck?', 'The wiki has every item, recipe, creature and place, with where to find them.'],
];

export function setupGuide() {
  const url = wikiUrl();
  document.querySelectorAll<HTMLAnchorElement>('a[data-wiki]').forEach(a => { a.href = url; a.target = '_blank'; a.rel = 'noopener'; });
  const sheet = document.getElementById('howto');
  if (!sheet) return;
  const list = sheet.querySelector('.howto-list');
  if (list && !list.childElementCount) list.innerHTML = HOW.map(([h, t]) => `<div><b>${h}</b><p>${t}</p></div>`).join('');
  const open = () => { sheet.hidden = false; (sheet.querySelector('.howto-close') as HTMLElement | null)?.focus(); };
  const close = () => { sheet.hidden = true; };
  document.querySelectorAll<HTMLElement>('[data-howto]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));
  sheet.querySelectorAll<HTMLElement>('.howto-close').forEach(b => b.addEventListener('click', close));
  sheet.addEventListener('click', e => { if (e.target === sheet) close(); });
  window.addEventListener('keydown', e => { if (e.key === 'Escape' && !sheet.hidden) close(); });
}
